export default "__VITE_ASSET__CJbnc7Z3__"